import CircularProgress from "@mui/material/CircularProgress";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import * as constants from "../../../constants";
import { RootState } from "../../../store/store";
import "./QBOSetup.css";
// import toast from "react-hot-toast";
import { Box, FormHelperText } from "@mui/material";
import { useTranslation } from "react-i18next";
import environment from "../../../environments/environment";
import { axiosInterceptor } from "../services/authInterceptor";
import { omiOAuth } from "./omiOAuth";

import {
  StyledButtonContainer
} from "../StyledComponents/Button";
import {
  SectionTitle,
  StyledOneChildContainer,
  StyledParentContainer
} from "../StyledComponents/Container";
// Get Participant Info
type ContactInfoProps = {
  view: string;
};

// create interface to define the type in setApiData useState
// Define the structure of your data here - should be same as the API data

const QBOSetup: React.FC<ContactInfoProps> = () => {
  //correct the both names below
  const GET_CONNECTION_SETUP = environment.qboConnectionSetupURL;
  const GET_CONNECTION_PARTICIPANT_CONFIGURED =
    environment.qboConnectionParticipantConfiguredURL;

  const userDetails = useSelector((state: RootState) => state.auth);

  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [message, setMessage] = useState<string | null>(null);
  const [trigger, setTrigger] = useState<boolean>(false);
  const [popup, setPopup] = useState<Window | null>(null);

  const contactInformation = useSelector(
    (state: RootState) => state.participantAdminProfile
  );
  const contactInformationID = useSelector(
    (state: RootState) => state.participantDetails
  );
  const { authResult } = omiOAuth();
  const { t } = useTranslation();
  const translate = t as (key: string) => string;
  //  const [data, setData] = useState<DataType[]>([]);

  const [qboSettingValue, setQboSettingValue] = useState<string | null>(null);

  const clientId: number = 1;
  const strVar: string | number | undefined =
    contactInformationID.participantId;
  const omiPartId: number = Number(strVar);

  const sessionIdRef = useRef(crypto.randomUUID());

  useEffect(() => {
    if (!sessionIdRef.current) {
      //  const newSessionId = crypto.randomUUID();
      sessionIdRef.current = crypto.randomUUID();
    }
  }, []);

  const sessionIdgen = sessionIdRef.current;

  const trimmedSessionId =
    sessionIdgen.length > 16 ? sessionIdgen.substring(0, 16) : sessionIdgen;

  // get qbo setup url
  const handleClick = async () => {
    getQboResponseById(omiPartId, clientId, trimmedSessionId);

    try {
      const response = await axiosInterceptor.get(
        `${GET_CONNECTION_SETUP}${omiPartId}?clientId=${clientId}&sessionId=${trimmedSessionId}`
      );

      if (response && response.status === constants.STATUS_CODES.SUCCESS) {
        const qboURL = response.data.data;
        const width = 700;
        const height = 700;
        const left = window.screen.width / 2 - width / 2;
        const top = window.screen.height / 2 - height / 2;

        const features = `width=${width},height=${height},left=${left},top=${top}`;

        // open inTuit Login Window

        const authWindow = window.open(
          qboURL[0].redirectUrl,
          "authPopup",
          features
        );

        if (!authWindow) {
          setError("Popup blocked. Please allow popups for this site.");
          return;
        }

        setPopup(authWindow);
      }
    } catch (error) {
      console.log(error);
    }
  };

  function handleCancel(event: React.MouseEvent<HTMLButtonElement>) {
    event.preventDefault();
  }

  useEffect(() => {
    getQboResponseById(omiPartId, clientId, trimmedSessionId);
  }, []); // Empty dependency array ensures this runs only once on mount

  // participantId: p.participantId,
  async function getQboResponseById(
    participantId: number,
    clientId: number,
    qboSessionId: string
  ) {
    setLoading(true); // Set loading to true before fetching data
    setError(null); // Clear any previous errors
    try {
      const response = await axiosInterceptor.get(
        `${GET_CONNECTION_PARTICIPANT_CONFIGURED}${participantId}?clientId=${clientId}`
      );

      if (response && response.status === constants.STATUS_CODES.SUCCESS) {
        const qboDetails = response.data.data;
        setQboSettingValue(qboDetails[0].connectionSettingExists);

        if (qboDetails[0].connectionSettingExists === false) {
          setTrigger(false);
        } else {
          console.log(qboDetails[0].connectionSettingExists);
        }
      }
    } catch (error: any) {
      setError(error.message);

      if (error.response?.status === constants.STATUS_CODES.NOT_FOUND) {
        console.log(omiPartId);
        console.log(clientId);
        console.log(qboSessionId);
      }
    } finally {
      setLoading(false); // Set loading to false after fetch is complete (success or error)
    }
  }

  // Load spinner

  if (loading) {
    return <CircularProgress />;
  }

  return (
    <StyledParentContainer>
      <StyledOneChildContainer>
        <Box sx={{ width: "100%" }}>
          <SectionTitle>QuickBooks Authentication Setup Page</SectionTitle>
          <FormHelperText
            style={{ paddingLeft: "16px", color: "#0A558C", fontSize: "25px" }}
          >
            Welcome {userDetails.userName}!
          </FormHelperText>

          {message && (
            <div style={{ marginTop: "1rem", color: "green" }}>{message}</div>
          )}

          <StyledButtonContainer>
            {!qboSettingValue && !authResult ? (
              <button className="login-button" onClick={handleClick}>
                Login to QuickBooks
              </button>
            ) : (
              <div className="auth-result">
                <FormHelperText
                  style={{
                    textAlign: "center",
                    color: "#2CA01C",
                    fontSize: "25px",
                  }}
                >
                  You're now connected to QuickBooks. Your session is
                  ready!🎉🎉🎉
                  <p
                    style={{
                      textAlign: "center",
                      color: "#000",
                      fontSize: "20px",
                    }}
                  >
                    Please{" "}
                    <a href="#" onClick={handleClick}>
                      click here
                    </a>{" "}
                    to reconfigure your QBO integration.
                  </p>
                </FormHelperText>
              </div>
            )}
          </StyledButtonContainer>
        </Box>
      </StyledOneChildContainer>
    </StyledParentContainer>
  );
};

export default QBOSetup;
